var _style, _circle, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _circle2, _path8, _path9, _path10, _circle3, _ellipse2, _ellipse3, _path11, _path12, _path13, _path14, _circle4, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 222 203.2",
    style: {
      enableBackground: "new 0 0 222 203.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADE0D9;}\n\t.st1{fill:none;stroke:#FBDC8E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#1F161E;}\n\t.st3{fill:#F8CDBA;}\n\t.st4{fill:#00AF9A;}\n\t.st5{fill:#176385;}\n\t.st6{fill:#FA9E9F;}\n\t.st7{fill:none;stroke:#1F161E;stroke-width:1.2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#1F161E;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_91",
    className: "st0",
    cx: 117.5,
    cy: 101.6,
    r: 101.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_167",
    className: "st1",
    x1: 49.9,
    y1: 176.4,
    x2: 56.4,
    y2: 173.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3773",
    className: "st2",
    d: "M109.2,74.8c1.7,0.3,3.4,0.4,5.2,0.2c1.8-0.3,1.6-4.1-0.6-4.2S109.2,74.8,109.2,74.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3774",
    className: "st2",
    d: "M96.9,123.2c-0.7,2.1-7.4,29.2-8.7,30.5s-37.4,20-37.4,20l2.5,6.2c0,0,37.9-12.1,39.8-13.2 s16.9-14.2,19.2-19.7S99.5,123.1,96.9,123.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3775",
    className: "st2",
    d: "M133.2,197.1c0,0.6-0.4,4.6,0.4,4.9s8.7,0.6,9.1,0.2s0.6-1.1,0.3-1.3s-3.4-0.8-3.8-1.1 c-0.6-0.7-0.9-1.7-0.8-2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3776",
    className: "st2",
    d: "M51.1,174.3c-0.6,0.2-4.3,1.4-4.4,2.2s2.8,8.3,3.3,8.5s1.3,0.1,1.3-0.3s-0.5-3.5-0.4-4 c0.4-0.9,1.2-1.5,2.2-1.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3777",
    className: "st3",
    d: "M131.8,107.7c-0.8,0.2-7,1.8-7.7,1.8s-1.6,6.3-0.9,6.2s8.8-2.5,10.9-2.7 S131.8,107.7,131.8,107.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3778",
    className: "st4",
    d: "M109,80.6c4.6-0.4,13.2,1.8,15.9,3.3c5.3,3-0.8,42.4-3.6,45.3c-2.5,1-23.4-3.9-24.4-6 c0.6-4.2,8.9-18.8,9.6-19.6c-0.5-0.5-2.9-3.4-2.9-3.4s2.1-2.9,2.4-3c-0.7-0.5-7.5-5.8-7.8-6.1C99.5,89.1,107.4,80.7,109,80.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3779",
    className: "st3",
    d: "M115.7,114.7c-0.4-0.9-11.6-14-12-14.6c0.6-0.9,1.6-2.2,2.5-3.1c-3.2-2.3-6.6-5-7.9-6.1 c0,0,0,0.1-0.1,0.1c-0.6,0.7-5.6,8.1-5.6,9.2s15.3,15.9,17.2,16.7S116,115.6,115.7,114.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_92",
    transform: "matrix(0.5471 -0.8371 0.8371 0.5471 -46.091 148.1016)",
    className: "st3",
    cx: 113.8,
    cy: 116.6,
    rx: 4.1,
    ry: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_93",
    className: "st3",
    cx: 133.6,
    cy: 110.1,
    r: 3.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3780",
    className: "st5",
    d: "M121.3,129.2c0,0,10.6,20.9,12.3,25.2s5.6,42.9,5.6,42.9s-5.3,0.6-6.7,0s-7.3-28.7-10.6-34.4 c-5-8.7-31.9-25-25-39.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3781",
    className: "st3",
    d: "M113.4,82.8c-0.1,0.7,5.4,1.7,5.6,1l1.2-6.9l-5.6-1L113.4,82.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3782",
    className: "st2",
    d: "M118.3,78.7c-0.5-0.1-4.3,0.8-4.4,1.7l0.8-4.5C115.5,76,118.3,78.7,118.3,78.7z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_94",
    className: "st3",
    cx: 120.4,
    cy: 71.5,
    r: 7.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_95",
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 31.6495 186.6651)",
    className: "st6",
    cx: 127.4,
    cy: 74.4,
    rx: 0.7,
    ry: 1.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_96",
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 26.0945 176.9449)",
    className: "st6",
    cx: 118.8,
    cy: 72.9,
    rx: 0.7,
    ry: 1.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3783",
    className: "st7",
    d: "M124.3,72.3c0.2,0.4,1.2,2.2-0.3,2.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3784",
    className: "st7",
    d: "M121,76.2c-0.5-0.2-1-0.7-1.2-1.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3785",
    className: "st8",
    d: "M105.7,97.6c1.4-1.8,3-3.5,4.6-5.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3786",
    className: "st2",
    d: "M121.5,60.9c-2.1,0-8.3-1-9.9-2.1c-1.8,1.8-3.4,4-4.5,6.3l3.3,2.6l-3.9-1.2 c-0.8,1.7-1.2,3.5-1.3,5.4c1.1,1.7,2.9,2.9,5,3.1c3.7,0,4.4-5.8,6.1-6.7c3-1.6,7,1.1,11.5,0.3C128.5,66.3,126.5,60.9,121.5,60.9z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_97",
    className: "st3",
    cx: 113,
    cy: 71.1,
    r: 1.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3787",
    className: "st2",
    d: "M106.8,114.6c-0.7-0.6-6.8,0.3-8.1,3.6c1.7-3.7,3.3-6.8,3.8-7.6 C103,111.1,106.8,114.6,106.8,114.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3788",
    className: "st2",
    d: "M125.8,109.7c-0.1,1.1,0.8,5.1,2.8,4.6l-3.6,1L125.8,109.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3799",
    className: "st9",
    d: "M0,55.5c0-3.8,9.5-4.6,13.3-4.6c7.6,0,8.1-4.4,14.5-4.4c5.6,0,8.4,4.5,13.6,4.5 c11.1,0,13.6-12.8,24.4-12.8c11,0,10.4,13.4,20.7,13.4c5.2,0,36.5,1,36.5,3.9L0,55.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3800",
    className: "st9",
    d: "M151.6,71.7c0-2.4,8.2-6.2,12.8-6.2c8.9,0,6.1,3.1,11.7,3.1c6.4,0,7.8-13.8,17.5-13.8 c10.6,0,8.9,13.5,15.4,13.5c2.8,0,4.2-1.3,8.2-1.3c2.6,0.2,4.6,2.2,4.8,4.7L151.6,71.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3811",
    className: "st9",
    d: "M0,135.1c0-2.4,8.2-6.2,12.8-6.2c8.9,0,6.1,3.1,11.7,3.1c6.4,0,7.8-13.8,17.5-13.8 c10.6,0,8.9,13.5,15.4,13.5c2.8,0,4.2-1.3,8.2-1.3c2.6,0.2,4.6,2.2,4.8,4.7L0,135.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3812",
    className: "st9",
    d: "M160.7,160.4c0-1.8,6.1-4.6,9.5-4.6c6.6,0,4.5,2.3,8.7,2.3c4.7,0,5.8-10.2,13-10.2 c7.9,0,6.6,10,11.5,10c2.1,0,3.1-1,6.1-1c1.9,0.1,3.4,1.6,3.6,3.5L160.7,160.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedImage);
export default __webpack_public_path__ + "static/media/completed_image.1e5bcb5f.svg";
export { ForwardRef as ReactComponent };